import { useSupportUserStatus } from "@src/features/tenants";
import { FEATURE_FLAGS, useBooleanFlag } from "@src/services/feature-flags/feature-flags";

/**
 * Whether the sidebar offers Patriot tools: support users, behind the
 * `patriot_tools` flag.
 *
 * The flag only decides whether the entry is offered. The routes gate on the
 * support role alone (see the section's `_layout.web.tsx`), and the API gates on
 * it again server-side, so the flag grants nothing by itself.
 *
 * `useBooleanFlag` rather than `getBooleanFlag` so the React Compiler cannot
 * freeze the answer at its first-render value — see `useClipCompilationAccess`.
 */
export function useShowPatriotToolsInSidebar(): boolean {
  const isEnabled = useBooleanFlag(FEATURE_FLAGS.PATRIOT_TOOLS);
  const supportStatus = useSupportUserStatus();
  return isEnabled && supportStatus === "granted";
}
